/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-11 16:16:47
 */

export default  {
  path: 'settlement',
  component: () => import(/* webpackChunkName: "settlement-list" */ '@/pages/settlement/List'),
  meta: {title:'银行账户',cate:'所有商户管理'},
  children: [
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "settlement-create" */ '@/pages/settlement/CreateEdit'),
      meta: {title:'添加公司'},
    },
    {
      path: ':id/edit',
      component: () => import(/* webpackChunkName: "settlement-edit" */ '@/pages/settlement/CreateEdit'),
      meta: {title:'编辑公司'},
    },
    {
      path: ':id/view',
      component: () => import(/* webpackChunkName: "settlement-view" */ '@/pages/settlement/CreateEdit'),
      meta: {title:'查看公司'},
    }
  ]
}